import styled from 'styled-components'
import { themeGet } from 'styled-system'
import {
  BodyCopy,
  CircleRightArrowIcon,
  ContainedButton,
  Hairline,
  HeaderOne,
  HeaderThree,
  HeaderTwo,
  SearchSelect,
  TextLink,
} from 'secondstep-components'
import TextLinkWithFileIcon from 'components/TextLinkWithFileIcon'

export const ColumnWrapper = styled.div.attrs(({ breakpointTablet }) => ({
  marginLeftEvenTablet: breakpointTablet ? '0' : '1.25rem',
  marginTablet: breakpointTablet ? '0.5rem 0 0' : '0',
  maxWidthTablet: breakpointTablet ? '100%' : 'calc(50% - 0.625rem)',
  flexTablet: breakpointTablet ? '1' : '1 0 calc(50% - 0.625rem)',
}))`
  background-color: ${props =>
    props.isComplete ? themeGet('colors.paleGray') : 'initial'};

  display: flex;
  flex-direction: column;
  flex: 1;

  &:not(:first-of-type) {
    margin-left: 1.25rem;
  }

  ${themeGet('breakpoints.tablet')} {
    flex: ${({ flexTablet }) => flexTablet};
    max-width: ${({ maxWidthTablet }) => maxWidthTablet};
    margin: ${({ marginTablet }) => marginTablet};

    &:first-of-type {
      margin: 0;
    }

    &:not(:first-of-type) {
      margin-left: 0;
    }

    &:nth-child(even) {
      margin-left: ${({ marginLeftEvenTablet }) => marginLeftEvenTablet};
    }

    &:nth-child(4n + 3),
    &:nth-child(4n + 4) {
      margin-top: 0.5rem;
    }
  }

  ${themeGet('breakpoints.mobileLarge')} {
    flex: 1;
    max-width: 100%;
    margin: 0.5rem 0 0;

    &:nth-child(even),
    &:nth-child(4n + 3),
    &:nth-child(4n + 4) {
      margin-left: 0;
    }
  }
`

export const ColumnsWrapper = styled.div.attrs(({ breakpointTablet }) => ({
  flexDirection: breakpointTablet ? 'column' : 'row',
  flexWrap: breakpointTablet ? 'nowrap' : 'wrap',
}))`
  display: flex;

  ${themeGet('breakpoints.tablet')} {
    flex-direction: ${({ flexDirection }) => flexDirection};
    flex-wrap: ${({ flexWrap }) => flexWrap};
  }

  ${themeGet('breakpoints.mobileLarge')} {
    flex-direction: column;
    flex-wrap: nowrap;
  }
`

export const ContentPanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1.5625rem 1.25rem 0.5rem;
  box-sizing: border-box;
  border-radius: 0.625rem;
  background: ${themeGet('colors.white')};
`

export const HeaderBodyCopyWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const LinksWrapper = styled.div`
  display: flex;
`

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  height: 200px;

  svg {
    color: ${themeGet('colors.darkBlue')};
  }

  p {
    margin-top: 0.25rem;
    margin-left: 0.5rem;
    font-size: 1.125rem;
    font-family: ${themeGet('font.molde.medium')};
    color: ${themeGet('colors.darkGray')};
  }
`

export const StyledBodyCopy = styled(BodyCopy)`
  margin-bottom: 0.875rem;
  color: ${themeGet('colors.darkGray')};
`

export const StyledContainedButton = styled(ContainedButton)`
  align-self: flex-start;
  width: 186px;
  padding: 0.6875rem 0.8125rem 0.5rem;
  margin-top: auto;
  margin-bottom: 1.25rem;
  text-align: center;
  text-transform: none;
  font-weight: normal;

  &:hover {
    box-shadow: none;
  }
`

export const StyledHairline = styled(Hairline)`
  height: 2px;
  margin-top: 1.4375rem;
  margin-bottom: 1.25rem;
  background-color: ${themeGet('colors.paleGray')};

  ${themeGet('breakpoints.mobile')} {
    margin-top: 0.9375rem;
  }
`

export const StyledHeaderThree = styled(HeaderThree)`
  font-size: 1rem;
  font-size: 1.0625rem;
  font-family: ${themeGet('font.sharpSlab.semibold')};

  ${themeGet('breakpoints.tablet')} {
    font-size: 1rem;
    line-height: 1.0625rem;
    margin-bottom: 0.75rem;
  }
`

export const StyledHeaderTwo = styled(HeaderTwo)`
  color: ${props =>
    props.isComplete
      ? themeGet('colors.darkBlue')
      : themeGet('colors.highschool.pink1')};

  font-size: 1.4375rem;
  line-height: 1.5625rem;
  margin-bottom: 0;

  ${themeGet('breakpoints.mobile')} {
    font-size: 1.4375rem;
    line-height: 1.5625rem;
  }
`

export const StyledHeaderOne = styled(HeaderOne)``

export const StyledImage = styled.img`
  max-width: 100%;
  border-radius: 10px;
  margin-bottom: 0.75rem;

  ${themeGet('breakpoints.tablet')} {
    margin-bottom: 1.1875rem;
  }
`

export const StyledTextLink = styled(TextLink)`
  width: fit-content;
`

export const StyledTextLinkWithFileIcon = styled(TextLinkWithFileIcon)`
  width: fit-content;
`

export const ImageLinkListWrapper = styled.div`
  display: flex;
  background-color: ${themeGet('colors.paleGray')};
`

export const ImageWrapper = styled.div`
  flex: 1;
  width: 100%;
`

export const LinkListWrapper = styled.div`
  flex: 1;
`

export const StyledCircleRightArrowIcon = styled(CircleRightArrowIcon)`
  height: 23px;
  width: 23px;
  margin-bottom: 0 !important;
  padding-left: 0.75rem;
`

export const StyledLinkDropdown = styled(SearchSelect)`
  padding-top: 0.5rem;
  padding-left: 1.75rem;

  svg {
    color: ${themeGet('colors.darkBlue')};

    &:last-of-type {
      width: 14px;
      height: 12px;
      margin-left: auto;
    }
  }

  span {
    color: ${themeGet('colors.darkBlue')};
    font-family: ${themeGet('fontFamilySemibold')};
  }

  [class*='LabelWrapper'] {
    display: none;
  }

  [class*='DropdownButton'] {
    border: unset;
    border-radius: 15px;
    height: 31px;

    &:hover {
      svg,
      span {
        color: ${themeGet('colors.blue')};
      }
    }

    ${themeGet('breakpoints.tablet')} {
      width: 12rem;
    }
  }

  [class*='DropdownOptions'] {
    border: none;
    border-radius: 0.3125rem;
    box-shadow: 0 0 22px rgba(0, 0, 0, 0.2);
    margin-top: 0.625rem;
    padding: 0.25rem 0;
    width: 18rem;

    button {
      padding: 0.125rem 1rem;

      svg {
        padding-left: 0.5rem;
      }
    }

    button:not(:last-child) {
      border-bottom: solid 1px ${themeGet('colors.paleGray')};
    }

    @media screen and (max-width: 1050px) {
      right: 0;
    }

    ${themeGet('breakpoints.tablet')} {
      right: unset;
    }
  }

  [class*='DropdownSpaceFiller'] {
    display: none;
  }

  ${themeGet('breakpoints.tablet')} {
    padding-left: 0;
  }
`
